import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isNil } from 'lodash';
import { useSnackbar } from 'notistack';
import { CompaniesService } from 'api';
import { COMPANY_ZANBATO_BID_PRICING_QUERY_KEY } from 'common/constants/services/companies';

const useGetCompanyZanbatoBidPricing = (companyId: number | undefined) => {
  const { enqueueSnackbar } = useSnackbar();

  const { data, isLoading, isError } = useQuery({
    enabled: !isNil(companyId),
    queryFn: () => CompaniesService.apiCompaniesZanbatoBidPricingRead(companyId as number),
    queryKey: [COMPANY_ZANBATO_BID_PRICING_QUERY_KEY, companyId],
    retry: false,
  });

  useEffect(() => {
    if (isError) {
      enqueueSnackbar('An error occurred loading Bid Pricing data.', { variant: 'error' });
    }
  }, [isError, enqueueSnackbar]);

  return { data, isLoading, isError };
};

export default useGetCompanyZanbatoBidPricing;
